import calc from "../assets/images/calc.svg";
import clock from "../assets/images/clock.svg";
import { addComma, gregorianToJalali } from "../lib/helperFunctions";
import { faArrowDown, faArrowUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useContext, useState } from "react";
import { DataContext } from "../index";

function NimaiiTable() {
  const dataContext = useContext(DataContext);
  const [showCal, setShowCal] = dataContext.showCalc;
  const nimaiiPrice = dataContext.nimaiiPrice;
  const updatedAt = gregorianToJalali(nimaiiPrice[0].updatedAt);



  return (
    <>
      <div className="nimaii-table-container">
        <div className="nimaii-table-header">
          <div className="table-header-bg-nimaii"></div>
          <section className="nimaii-table-label"> نرخ ارز نیمایی</section>
          <section className="table-status">
            <span className="last-update-label">
              <span> آخرین بروزرسانی </span>
              <span>
                <img src={clock} />
              </span>
            </span>
            <span className="last-update-time">
              <span>
                {new Date(nimaiiPrice[0].updatedAt).toString().split(" ")[4]}
              </span>
              <span>
                {updatedAt.year + "/" + updatedAt.month + "/" + updatedAt.day}
              </span>
            </span>
            <span
              className="calculator"
              onClick={() => {
                setShowCal(!showCal);
              }}
            >
              <span>ماشین حساب</span>
              <span>
                <img src={calc} />
              </span>
            </span>
          </section>
        </div>
        <table className="nimaii-table">
          <thead>
            <tr>
              <th></th>
              <th>ارز</th>
              <th>خرید</th>
              <th></th>
              <th>فروش</th>
              <th></th>
            </tr>
          </thead>
          {nimaiiPrice?.map((item, i) => {
            const buyPriceStatus =
              Number(item.buyPrice) > Number(item.pBuyPrice);
            const sellPriceStatus =
              Number(item.sellPrice) > Number(item.pSellPrice);
            return (
              <tr>
                <td>
                  <img
                    className={`flag-nimaii`}
                    src={`/flags/currencies/${item.nimaii.symbol}@2x.png`}
                  />
                </td>
                <td className={``}>{item.nimaii.name}</td>
                <td
                  className={`price ${
                    buyPriceStatus ? `green-price` : `red-price`
                  }`}
                >
                  {addComma(item.buyPrice)}
                </td>
                <td>
                  {buyPriceStatus ? (
                    <FontAwesomeIcon
                      icon={faArrowUp}
                      style={{ color: "green" }}
                    />
                  ) : (
                    <FontAwesomeIcon
                      icon={faArrowDown}
                      style={{ color: "red" }}
                    />
                  )}
                </td>
                <td
                  className={`price ${
                    sellPriceStatus ? `green-price` : `red-price`
                  }`}
                >
                  {addComma(item.sellPrice)}
                </td>
                <td>
                  {sellPriceStatus ? (
                    <FontAwesomeIcon
                      icon={faArrowUp}
                      style={{ color: "green" }}
                    />
                  ) : (
                    <FontAwesomeIcon
                      icon={faArrowDown}
                      style={{ color: "red" }}
                    />
                  )}
                </td>
              </tr>
            );
          })}
        </table>
      </div>
    </>
  );
}
export default NimaiiTable;
